<template>
    <div style="width: 100%">
        <gmap-map style="width: 100%; height: 100%" v-bind="$attrs" v-on="$listeners">
            <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
                <slot :name="slot" v-bind="scope"></slot>
            </template>
        </gmap-map>
    </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_GOOGLE_API_KEY,
        libraries: 'places',
    },
});

export default {
    name: 'BGoogleMap',
};
</script>
